<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" :width="width" :height="height"><g stroke-linecap="round" stroke-linejoin="round" :stroke-width="strokewidth" :fill="_secondaryfill" :stroke="_secondaryfill"><path fill="none" d="M8,33.488V38 c0,3.314,2.686,6,6,6h3"></path> <path fill="none" d="M8,16.512V16C8,8.268,14.268,2,22,2h4 c7.732,0,14,6.268,14,14v0.512" :stroke="fill"></path> <path fill="none" d="M13,16.231 C12.356,16.084,11.688,16,11,16c-4.971,0-9,4.029-9,9s4.029,9,9,9c0.688,0,1.356-0.084,2-0.231V16.231z" :stroke="fill"></path> <path fill="none" d="M35,16.231 C35.644,16.084,36.312,16,37,16c4.971,0,9,4.029,9,9s-4.029,9-9,9c-0.688,0-1.356-0.084-2-0.231V16.231z" :stroke="fill"></path> <rect x="17" y="42" fill="none" width="12" height="4"></rect></g></svg></template>

<script>
export default {
	props: {
		width: {
			type: [Number, String],
			default: "100%"
		},
		height: {
			type: [Number, String],
			default: "100%"
		},
		strokewidth: {
			type: [Number, String],
			default: 1
		},
		fill: {
			type: String,
			default: "currentColor"
		},
		secondaryfill: {
			type: String
		}
	},
	computed: {
		_secondaryfill: function () {
			return this.secondaryfill || this.fill
		}
	}
}
</script>